import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import styles from "./About.module.css";
import { Droplet, Truck, Factory, Heart, Zap } from "lucide-react";

import servicesbg1 from "../../Assests/Images/ourValue1.png";
import servicesbg2 from "../../Assests/Images/ourValue2.png";
import servicesbg3 from "../../Assests/Images/ourValue3.png";
import servicesbg4 from '../../Assests/Images/ourValue4.png';
// import servicesbg5 from '../../Assests/Images/ourValue5.png';


import indus1 from "../../Assests/icons/ourvaluesvg1.svg";
import indus2 from "../../Assests/icons/ourvaluesvg2.svg";
import indus3 from "../../Assests/icons/ourvaluesvg3.svg";
import indus4 from '../../Assests/icons/ourvaluesvg4.svg';
// import indus5 from '../../Assests/icons/ourvaluesvg5.svg';

import arrowleft from "../../Assests/icons/leftArrow.svg";
import arrowright from "../../Assests/icons/rightArrow.svg";

const industries = [
  {
    title: "Commitment to Quality",
    description:
      "We uphold the highest standards in every product and service, ensuring consistent reliability and excellence.",
    icon:indus1,
    image: servicesbg1,
  },

  {
    title: "Transparency & Integrity",
    description:
      "We operate with honesty, accountability, and clear communication, fostering trust with every client and supplier.",
    icon: indus3,
    image: servicesbg3,
  },
  {
    title: "Innovation in Supply Chain",
    description:
      "We uphold the highest standards in every product and service, ensuring consistent reliability and excellence.",
    icon: indus4,
    image: servicesbg4,
  },
  {
    title: "Client-Centric Service",
    description:
      "We build long-term partnerships with a focus on personalized, results-driven solutions.",
    icon:indus2,
    image: servicesbg2,
  },
  // {
  //   title: "Utilities",
  //   description: "Dependable and scalable solutions ensuring seamless service delivery and long-term success of critical infrastructure.",
  //   icon:indus5,
  //   image: servicesbg5,
  // },
];


const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 3000, min: 2000 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 2000, min: 1200 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1200, min: 940 },
      items:3,
    },
    mobile: {
      breakpoint: { max: 940, min: 500 },
      items: 2,
    },
    small: {
      breakpoint: { max: 500, min: 0 },
      items: 1,
    },
  };
  
  
  const arrowStyle = {
    background: "transparent",
    border: 0,
    color: "#000000",
    fontSize: "80px",
    display:"none"
  };
  const CustomRight = ({ onClick }) => (
    <button className={styles.arrowright} onClick={onClick} style={arrowStyle}>
      <img src={arrowright} alt="next" style={{ width: 18 }} />
    </button>
  );
  
  const CustomLeft = ({ onClick }) => (
    <button className={styles.arrowleft} onClick={onClick} style={arrowStyle}>
      <img src={arrowleft} alt="previous" style={{ width: 18 }} />
    </button>
  );

export function LetsPartnerSection() {
  return (
    <section className={styles.letsPartnerSection}>
    <div className={styles.header}>
      <h2 className={`${styles.heading} mb-0`}>Our Values</h2>
      {/* <p className={styles.subheading}>
        Expert Procurement Services for Critical Global Industries
      </p> */}
    </div>

    <Carousel
      responsive={responsive}
      // autoPlay={true}
      swipeable={true}
      draggable={true}
      infinite={true}
      keyBoardControl={true}
      arrows
      partialVisible={false}
      className={styles.curoselList}
      itemClass={styles.carouselItem}
      customRightArrow={<CustomRight />}
      customLeftArrow={<CustomLeft />}
    >
      {industries.map((industry, index) => (
        <div key={index} className={styles.card}>
          <div className={styles.imageWrapper}>
            <img src={industry.image} alt={industry.title} className={styles.image} />
            <div className={styles.overlay}></div>
          </div>
          <div className={styles.content}>
            <div className={styles.iconWrapper}>
              <img src={industry.icon} alt="" />
            </div>
            <h3 className={styles.title}>{industry.title}</h3>
            <p className={styles.description}>{industry.description}</p>
          </div>
        </div>
      ))}
    </Carousel>
  </section>
);
}
